export const isDevMode = () => {  
  // return process.env.NODE_ENV !== "development";
  return process.env.NODE_ENV === "development";
};

export const isNodeEnv = isDevMode();